import { useEffect, useState } from "react";

interface Props {
  words: string[];
  intervalMs?: number;
}

export const RotatingWord = ({ words, intervalMs = 2200 }: Props) => {
  const [i, setI] = useState(0);
  useEffect(() => {
    if (words.length <= 1) return;
    const id = setInterval(() => setI((v) => (v + 1) % words.length), intervalMs);
    return () => clearInterval(id);
  }, [words.length, intervalMs]);

  return (
    <span key={i} className="inline text-primary animate-fade-up">
      {words[i]}
    </span>
  );
};